module.exports = __webpack_public_path__ + "img/iconfinder_Rounded_Facebook_svg_5282541.c40332a2.svg";